import axios from 'axios';
import { ContentBatchModel } from '../Models/ContentBatchModel';

const updateContentBatch = (batch: ContentBatchModel) => axios.patch(`classifications/categories/${batch.categoriesId[0]}/contents/update-batch`, batch);

export default { 
    updateContentBatch
};